/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

module.exports = {
  SIDENAV_WIDTH: 'var(--spectrum-global-dimension-static-size-3200)',
  // --spectrum-global-dimension-static-grid-fixed-max-width
  DESKTOP_SCREEN_WIDTH: process.env.GATSBY_DESKTOP_SCREEN_WIDTH || '1280px',
  DESKTOP_FOOTER_SCREEN_WIDTH_MAX: process.env.GATSBY_DESKTOP_FOOTER_SCREEN_WIDTH_MAX || '1280px',
  TABLET_SCREEN_WIDTH: '1024px',
  // --spectrum-global-dimension-static-breakpoint-small
  MOBILE_SCREEN_WIDTH: '768px'
};
